import script from "./MainFollowModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFollowModal.vue?vue&type=script&setup=true&lang=js"

import "./MainFollowModal.vue?vue&type=style&index=0&id=24aff08b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24aff08b"]])

export default __exports__